module.exports = __webpack_public_path__ + "img/vende_tu_auto_paso2_web.17af31cd.png";